// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_37qNJ","headline-wrapper":"_27nWF"};